module.exports = __webpack_public_path__ + "img/call.d93c9fac.svg";